<template>
    <a-form  layout='inline'>
       <a-form-item label="关键字">
           <a-input v-model:value="search.keyword" placeholder="请输入关键字搜索" style="width:240px"></a-input>
       </a-form-item>
        <a-form-item>
            <a-button type="primary" @click="changeTabs">搜索</a-button>
        </a-form-item>
    </a-form>
    <a-tabs v-model:activeKey="activeKey" class="m-t-20" @change="changeTabs">
      <a-tab-pane :key="1" tab="产品库"></a-tab-pane>
      <a-tab-pane :key="2" tab="礼品库" ></a-tab-pane>
    </a-tabs>
       <a-table :loading='loading' :columns='columns' :data-source='list' rowKey='sku_sn' bordered :pagination="pagination" @change="changePage">
           <template v-slot:goods="{record}">
               <div class="s_flex_ali">
                   <img :src="record.image?oss+record.image:'@/assets/images/normal.png'" style="width:70px;height:70px;border-radius:5px" class="m-r-15">
                   <div>
                        <span>{{record.name}}</span>
                        <p class="fz-12 s_c999 m-t-10">规格：{{record.sku_name || '-'}}</p>
                   </div>
               </div>
           </template>
           <template v-slot:action="{record}">
               <a-button type="primary" :disabled="disabled&&!record.checked" :ghost="!record.checked" @click="selectGoods(record)">{{record.checked?'已选择':'选择'}}</a-button>
           </template>
       </a-table>
        <a-button type="primary" style="margin-left:50%" class="m-t-10" @click="confirm">保存</a-button>
</template>
<script>
import config from "@/config";
import { productSkuList,giftSkuList } from "@/api/assets";
import { onMounted, reactive,toRefs,ref } from 'vue'
import { iscode } from '../../../../utils/app';
import { message } from 'ant-design-vue';
  const oss = config.oss[process.env.VUE_APP_type];
const columns = [
    {
        title: "ID",
       dataIndex: "id",
       width:100,
       align:'center'
    },
    {
        title: "商品信息",
       dataIndex: "image",
        slots: { customRender: "goods" }
    },
    {
       title: "产品库分类",
       dataIndex: "category_name",
        width:120,
        align:'center'
    },
    {
         title: "价格/元",
       dataIndex: "price",
       width:120,
       align:'center'
    },
    {
         title: "操作",
       dataIndex: "5",
       width:120,
       align:'center',
       slots: { customRender: "action" }
    }
]
export default{
    props:{
        goodsId:{
            type:Object,
            default:()=>{}
        }
    },
    setup(props,{emit}){
        const search = ref({
              keyword:'',
              page:1,
              limit:5
        })
        const state = reactive({
             keyword:'',
             loading:false,
             activeKey:1,
             list:[],
             pagination:{
                 total:0,
                 current:1,
                 pageSize:5,
                 defaultPageSize:5,
                 showSizeChanger:true, 
                 pageSizeOptions:['5', '10', '15', '20', '25'], 
                 showQuickJumper:true, 
                 showTotal:(total)=> `共 ${total} 条`,
             },
             allChecked:{},
             len:0,
             disabled:false
        })

        const methods ={
            async getList(){
                  state.loading = true;
                  let result=null;
                  state.list = [];
                  if(state.activeKey==1){
                     result = await productSkuList({...search.value}).then(res=>res.data)
                  }else{
                      result = await giftSkuList({...search.value}).then(res=>res.data)
                  }
                 if(iscode(result)){
                    state.list = result.data.data || [];
                    state.pagination.total = result.data.total || 0;
                    state.list.forEach((item)=>{
                          item.checked = false;
                         if(props.goodsId[item.id+'_'+item.sku_sn]){
                            item.checked = true;
                         }
                      })
                      state.loading = false;
                     console.log(state.allChecked,props.goodsId,'查看数组')
                     state.allChecked = props.goodsId || {};
                      state.len = Object.keys(state.allChecked).length;
                      if(state.len>=3) return state.disabled = true;
                 }else{
                     state.loading = false;
                     message.error(result.msg)
                 }
                 
             },
             changeTabs(e){
                 state.list = [];
                 search.value.page = 1;
                 state.pagination.current =1;
                 methods.getList()
             },
             selectGoods(record){
                //  console.log(record,'2')
                //  return 
                record.checked = !record.checked;
                if(record.checked){
                     state.allChecked[record.id+ '_'+ record.sku_sn] = record;
                     state.len = Object.keys(state.allChecked).length;
                     if(state.len>=3) return state.disabled = true;
                }else{
                    console.log(state.allChecked,state.allChecked[record.id+ '_'+ record.sku_sn],'选中前')
                    delete state.allChecked[record.id+ '_'+ record.sku_sn];
                    state.len = Object.keys(state.allChecked).length;
                    state.disabled = false;
                }
             },
             changePage(e){
                 console.log(e)
                 state.pagination.pageSize = e.pageSize;
                 state.pagination.current = e.current;
                 search.value.limit = e.pageSize;
                 search.value.page = e.current;
                 methods.getList()
             },
             confirm(){
                //  console.log(state.allChecked,'结果')
                //  let goodsList = Object.keys(state.allChecked) || [];
                console.log(state.allChecked,'234567')
                 emit('change',state.allChecked)
             }
        }
        onMounted(()=>{
            methods.getList()
        })
        return {
            oss,
            columns,
            ...toRefs(state),
            ...methods,
            search
        }
    }
}
</script>
